import axios from "axios";

import { message } from "@/utils/resetMessage";
import router from "@/router/index";
import Vue from "vue";
let vm = new Vue();

// 生成UUID的函数
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// 存储当前请求ID
let currentRequestId = generateUUID();

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_SERVER,
  timeout: 500000, // 请求超时
});
// let cancel = null;
//请求拦截
service.interceptors.request.use(
  (config) => {
    // 如果token存在所有请求都携带token
    if (localStorage.getItem("token")) {
      config.headers["Authorization"] =
        "Bearer " + localStorage.getItem("token");
    }
    // 添加X-Request-Id请求头
    config.headers["X-Request-Id"] = currentRequestId;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

//相应拦截
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    console.log(res);
    if (res.code && res.code !== 200) {
      message({
        showClose: true,
        message: res.msg,
        duration: 3000,
        type: "error",
      });
    } else {
      // 请求成功，生成新的UUID
      currentRequestId = generateUUID();
    }
    return res;
  },
  (error) => {
    if (error.response) {
      const res = error.response.data;

      if (res.code === 401) {
        // router.push("/login");
      } else {
        message.error(res.msg);
      }
    }
    // 请求失败，UUID保持不变
    return Promise.reject(error);
  },
);

export default service;
